import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const funcionImporterSelectors = importerSelectors(
  'funcion.importer',
);

export default funcionImporterSelectors;
